"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var UsersController = function UsersController(User) {
  "ngInject";

  (0, _classCallCheck3.default)(this, UsersController);
  var vm = this;
  vm.users = [];
  vm.pagination = {
    page: 0,
    limit: 25
  };
  vm.init = init;
  vm.openUser = openUser;
  init();

  function init() {
    User.getList(vm.pagination.page, vm.pagination.limit).then(function (res) {
      vm.users = res.data;
    });
  }

  function openUser(user) {
    console.log("Apri dettagli utente:", user);
  }
};

exports.default = UsersController;


// WEBPACK FOOTER //
// ./client/app/components/dashboard/users/users.controller.js